export default value => value.replace(/\s\s+/g, ' ').trim();
